// extracted by mini-css-extract-plugin
export default {"content":"LocationFeatures_content__Fn+RA"};